import { render, staticRenderFns } from "./TranslationModalConfirm.vue?vue&type=template&id=78aa0916&scoped=true&"
import script from "./TranslationModalConfirm.vue?vue&type=script&lang=js&"
export * from "./TranslationModalConfirm.vue?vue&type=script&lang=js&"
import style0 from "./TranslationModalConfirm.vue?vue&type=style&index=0&id=78aa0916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78aa0916",
  null
  
)

export default component.exports